import { calculateDiscount } from "../../../shared/helpers/mobile";

export const mobileCost = (
	value: any
): { dueToday: number; monthlyCost: number } => {
	let monthlyCost = 0;
	const dueToday = 0;
	if (value?.basePlan) {
		let fee = Number(value.basePlan.Fee);
		if (value.basePlan?.PromoDetails?.promoIsValid) {
			fee = calculateDiscount(fee, value.basePlan.PromoDetails);
		}
		monthlyCost += fee;
	}
	if (value?.addons) {
		value.addons?.forEach((addon) => {
			const fee = Number(addon.Fee);
			if (addon.IsRecurring) {
				monthlyCost += fee;
			}
		});
	}
	return {
		monthlyCost,
		dueToday,
	};
};
